<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      img: 'interrogation_mark.svg',
      bgColor: 'primary',
      textColor: 'white',
    }"
    :quasar-props="{
      noEscDismiss: true,
      noBackdropDismiss: true,
    }"
    :body="{ class: 'text-center' }"
    size="md"
  >
    <template #body>
      <h3 class="text-center">
        {{ $t("ETAB.PAGES.RECRUITMENT.FEEDBACK_FORM.@TITLE") }}
      </h3>

      <ExpiredRecruitmentFeedbackForm @save="onSubmitReview" />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ReviewDemandModel } from "@core/models";
  import { MEDIUM_TEXT_LENGTH_LIMIT } from "@core/constants";
  import { ExtracadabraModal } from "@core/components/modals";
  import ExpiredRecruitmentFeedbackForm from "@etab/components/recruitments/detail/ExpiredRecruitmentFeedback.form.vue";

  export default {
    components: {
      ExpiredRecruitmentFeedbackForm,
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      review: {
        type: Object,
        default: () => new ReviewDemandModel(),
      },
    },
    emits: ["update:opened", "onSubmitReview"],
    data() {
      return {
        comment: "",
      };
    },
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
      isValid() {
        return this.comment.length <= MEDIUM_TEXT_LENGTH_LIMIT;
      },
    },
    created() {
      this.MEDIUM_TEXT_LENGTH_LIMIT = MEDIUM_TEXT_LENGTH_LIMIT;
    },
    methods: {
      onSubmitReview({ comment }) {
        this.$emit("onSubmitReview", { review: this.review, comment });
      },
    },
  };
</script>

<style lang="scss">
  .review-demand-modal-header {
    white-space: normal; // allow for multiline

    h4 {
      line-height: 1.5;
      margin: 0;
    }
  }
</style>
